import { PageLayout } from '@retail/components';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { MemberCampaignDetailsContainer } from '@retail/campaign/containers';
import { useFetchMemberCampaignDetails } from '@retail/campaign/data-access';
import { CampaignType, MemberCampaign, MemberCampaignDTO } from '@retail/campaign/types';
import { usePermissionsForCurrentUser } from '@retail/app/stores/selected-context';

export const MemberCampaignDetailsPage = () => {
  const { campaignId, campaignType } = useParams();
  const { userCanUpdate, userCanDelete } = usePermissionsForCurrentUser();

  const { data: campaignDto } = useFetchMemberCampaignDetails({
    campaignId: campaignId ?? '',
    campaignType: campaignType as CampaignType,
    suspense: true,
  });

  const campaign = useMemo(() => {
    const isLocal = campaignDto?.campaignType === 'LOCAL';
    const canEdit = isLocal ? userCanUpdate('LOCAL_CAMPAIGN') : userCanUpdate('MEMBER_CAMPAIGN');
    const canDelete = isLocal ? userCanDelete('LOCAL_CAMPAIGN') : userCanDelete('MEMBER_CAMPAIGN');

    return MemberCampaign.fromDto({
      dto: campaignDto as MemberCampaignDTO,
      canEdit,
      canDelete,
    });
  }, [campaignDto, userCanDelete, userCanUpdate]);

  return (
    <PageLayout maxWidth="full" spacing={2} fixedHeight>
      <MemberCampaignDetailsContainer campaign={campaign} />
    </PageLayout>
  );
};
